import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "full-width nav-page-loading" }
const _hoisted_2 = { class: "q-mx-auto width-fit" }

import { computed } from "vue";
import { PrivatePageProps } from "@/types";
import { sessionStore } from "@/hooks";
import {
  FlexBox,
  Typography,
  Separator,
  BackButton,
} from "@/components/common";


/**
 * Displays a page with top and sidebars.
 */
const __default__ = {
  name: "PrivatePage",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    fullWindow: { type: Boolean },
    smallWindow: { type: Boolean },
    graph: { type: Boolean },
    title: {},
    subtitle: {},
    backToProject: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const doDisplay = computed(() => sessionStore.doesSessionExist);

const className = computed(() =>
  props.fullWindow
    ? "q-mx-auto q-pa-xl"
    : "q-mx-auto q-pa-lg nav-page-centered " +
      (props.smallWindow ? "width-fit" : "")
);

return (_ctx: any,_cache: any) => {
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!

  return (doDisplay.value)
    ? (_openBlock(), _createBlock(_component_q_page, {
        key: 0,
        padding: !props.fullWindow
      }, {
        default: _withCtx(() => [
          (!props.graph)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(className.value)
              }, [
                (props.backToProject)
                  ? (_openBlock(), _createBlock(_unref(BackButton), {
                      key: 0,
                      "to-project": "",
                      class: "q-mb-sm"
                    }))
                  : _createCommentVNode("", true),
                (!!props.title)
                  ? (_openBlock(), _createBlock(_unref(FlexBox), {
                      key: 1,
                      justify: "between",
                      align: "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Typography), {
                          el: "h1",
                          variant: "title",
                          value: props.title
                        }, null, 8, ["value"]),
                        _renderSlot(_ctx.$slots, "actions")
                      ]),
                      _: 3
                    }))
                  : _createCommentVNode("", true),
                (!!props.title)
                  ? (_openBlock(), _createBlock(_unref(Separator), {
                      key: 2,
                      b: "2"
                    }))
                  : _createCommentVNode("", true),
                (!!props.subtitle)
                  ? (_openBlock(), _createBlock(_unref(Typography), {
                      key: 3,
                      el: "p",
                      b: "2",
                      value: props.subtitle
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
              ], 2))
            : _renderSlot(_ctx.$slots, "default", { key: 1 })
        ]),
        _: 3
      }, 8, ["padding"]))
    : (_openBlock(), _createBlock(_component_q_page, { key: 1 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_q_circular_progress, {
                rounded: "",
                indeterminate: "",
                size: "60px",
                thickness: 0.2,
                color: "primary"
              })
            ])
          ])
        ]),
        _: 1
      }))
}
}

})